import { useCallback, useEffect, useState } from "react";
import { useGePortal } from "../../hooks/portal/portal.hook";
import { envChangeType, envType } from "../../plugins/utils";
import styles from "./styles.module.scss";

const Home = () => {
  const { data: portals, isLoading } = useGePortal({});
  const [redirecting, setRedirecting] = useState(false);

  const randomPortal = useCallback(() => {
    if (!portals || portals.length <= 0) return undefined;
    return portals[Math.floor(Math.random() * portals.length)];
  }, [portals]);

  useEffect(() => {
    const REDIRECT_DELAY_MS = envChangeType(
      "REACT_APP_WAITING_TIME",
      envType.NUMBER,
    );
    const timer = setTimeout(() => {
      const portal = randomPortal();
      if (!portal) return;
      setRedirecting(true);
      window.location.replace(`https://www.${portal}`);
    }, REDIRECT_DELAY_MS);
    return () => clearTimeout(timer);
  }, [randomPortal]);

  return (
    <div className={styles.homeContainer}>
      <div className={styles.card}>
        <div className={styles.spinner}>
          <span />
          <span />
          <span />
        </div>
        <p className={styles.label}>
          {isLoading || !portals
            ? "加载中…"
            : redirecting
              ? `重定向中…`
              : `连接中…`}
        </p>
      </div>
    </div>
  );
};

export default Home;
